import './styles.scss'

import React from 'react'
import { useValues, useMountedLogic, useActions } from 'kea'
import OtherCourses from '~/scenes/shared/profile/other-courses'
import Reputation from '~/scenes/shared/profile/reputation'
import Reviews from '~/scenes/shared/profile/reviews'
import GoodFit from 'lib/components/good-fit'
import ProfileHeader from '~/scenes/shared/profile/profile-header'
import Friends from '~/scenes/shared/profile/friends'
import logic from './logic'
import sceneSaga from './saga'
import Helmet from 'lib/tags/helmet'

const Public = () => {
  useMountedLogic(sceneSaga)

  const {
    id,
    userData,
    hasCourses,
    courses,
    reputation,
    reviews,
    facebookFriends,
    isTeacher,
    showAddVerificationLink,
    video,
    isLoading,
    translating,
    avatar,
    helmet
  } = useValues(logic)

  const { loadMore, translateReview } = useActions(logic)

  const teacherVideo = !video ? {} : video
  return (
    <div>
      {helmet && <Helmet helmet={helmet} />}
      <div className='tightrow'>
        <div className='eight columns'>
          <ProfileHeader user={userData} video={teacherVideo} avatar={avatar} />
          {hasCourses && (
            <div id='teacher_courses'>
              <OtherCourses courses={courses} />
            </div>
          )}
          <Reviews
            loadMore={loadMore}
            isLoading={isLoading}
            reviews={reviews}
            isTeacher={isTeacher}
            translateReview={translateReview}
            translating={translating}
          />
        </div>
        <div className='four columns profile-right'>
          <GoodFit mode='widget' />
          <Reputation reputation={reputation} showAddVerificationLink={showAddVerificationLink} />
          <Friends facebookFriends={facebookFriends} id={id} />
        </div>
      </div>
    </div>
  )
}

export default Public
